import { Injectable } from '@angular/core';
import { CanActivate, Route, UrlSegment, CanMatch } from '@angular/router';
import { FeatureFlagsService } from 'app/services/core/feature-flags.service';

@Injectable({
  providedIn: 'root',
})
export class FirmFeatureGuard implements CanMatch, CanActivate {
  constructor(private featureFlags: FeatureFlagsService) {}

  canMatch(route: Route, segments: UrlSegment[]): boolean {
    return this.isEnabled();
  }

  canActivate(): boolean {
    return this.isEnabled();
  }

  private isEnabled(): boolean {
    return this.featureFlags.enableFirms;
  }
}